import * as React from 'react';
import { Table, Checkbox, CheckboxProps } from 'semantic-ui-react';
import { FieldInputProps } from 'react-final-form';

import FieldValue from 'components/FieldValue';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import { APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/appliedFertilizerEntitiesByDate/constants';
import { SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/sprayedEntitiesByDate/constants';
import EntityTableRowSprayedStatusCell from './components/EntityTableRowSprayedStatusCell';
import EntityTableRowVarietyCell from './components/EntityTableRowVarietyCell';
import EntityTableRowNameCell from './components/EntityTableRowNameCell';
import EntityTableRowAppliedStatusCell from './components/EntityTableRowAppliedStatusCell';

interface Props {
    entityId: number;
    input: FieldInputProps<any, HTMLElement>;
    namespace:
        | typeof APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE
        | typeof SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE;
}

export default class RenderEntityTableRow extends React.PureComponent<Props> {
    handleChange = (
        _event: React.FormEvent<HTMLInputElement>,
        { id }: CheckboxProps
    ): void => {
        const {
            input: { onChange, ...input }
        } = this.props;
        const values = input.value || [];

        if (values.includes(id)) {
            const nextValues = values.filter((value: number) => value !== id);
            // remove id from values
            onChange(nextValues);
        } else {
            // Append id to values
            onChange([...values, id]);
        }
    };

    render(): React.ReactElement {
        const {
            input: { value },
            entityId,
            namespace
        } = this.props;

        const isSpray = namespace === SPRAYED_ENTITIES_BY_DATE_LOAD_NAMESPACE;

        return (
            <Table.Row textAlign="center">
                <Table.Cell collapsing className="events-table-cell-padding">
                    <Checkbox
                        id={entityId}
                        checked={value.includes(entityId)}
                        onChange={this.handleChange}
                    />
                </Table.Cell>
                <FieldValue name="entityId">
                    {(
                        spraySchemaEntityId: SprayEventEntityId
                    ): React.ReactElement => (
                        <EntityTableRowNameCell
                            entityId={entityId}
                            spraySchemaEntityId={spraySchemaEntityId}
                        />
                    )}
                </FieldValue>
                <EntityTableRowVarietyCell entityId={entityId} />
                {isSpray && (
                    <FieldValue name="startDate">
                        <EntityTableRowSprayedStatusCell entityId={entityId} />
                    </FieldValue>
                )}
                {!isSpray && (
                    <FieldValue name="startDate">
                        <EntityTableRowAppliedStatusCell entityId={entityId} />
                    </FieldValue>
                )}
            </Table.Row>
        );
    }
}
